import React, {Component} from 'react';
import "./AboutHonor.scss"
import HonorImg01 from "../../static/img/honor-01.jpg"
import HonorSwiper01 from "../../static/img/honor-swiper-01.jpg"
import HonorSwiper02 from "../../static/img/honor-swiper-02.jpg"
import HonorSwiper03 from "../../static/img/honor-swiper-03.jpg"
import HonorSwiper04 from "../../static/img/honor-swiper-04.jpg"
import HonorProduct01 from "../../static/img/honor-product-01.jpg"

import {Swiper, SwiperSlide} from "swiper/react"
import SwiperCore, {Navigation} from 'swiper';


import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';

SwiperCore.use([Navigation]);


class AboutHonor extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <div className="AboutHonor">
                <div className="honor-content">
                    <div className="left">
                        <div>
                            Corporate <span>Honor</span>
                        </div>
                        <div>
                            公司荣誉
                        </div>
                        <div>
                            公司借助丰富的行业经验和技术优势，通过自主研发的多款产品，有效推动了货运两端“降本增效”目标的实现，既提高了道路车辆的运行效率，又降低了经营企业的运营成本。依托互联网平台，运用大数据、云计算手段，结合物联网技术，搭建专业的、规模化的大宗商品智慧物流供应链管理平台。
                        </div>
                        <div>
                            profession
                        </div>
                    </div>
                    <div className="right">
                        <img src={HonorImg01} alt=""/>
                    </div>
                </div>
                <div className="honor-swiper">
                    <div className="honor-swiper-title">
                        <div className="title">
                            Honor <span>Certificate</span>
                        </div>
                        <div className="text">
                            荣誉证书
                        </div>
                    </div>
                    <div className="honor-swiper-list">
                        <Swiper
                            className="swiper-no-swiping"
                            initialSlide={0}   //初始化时的索引位置
                            slidesPerView={2}
                            speed={1000} //页面切换速度，slider自动滑动开始到结束的时间（单位ms）
                            loop={true} //是否形成环路
                            navigation={{
                                nextEl: '.swiper-honor-next',
                                prevEl: '.swiper-honor-prev',
                            }}
                        >
                            <SwiperSlide>
                                <div className="item">
                                    <div className="icon">
                                        <img src={HonorSwiper01} alt=""/>
                                    </div>
                                    <div className="text">
                                        营业执照
                                    </div>
                                </div>
                            </SwiperSlide>
                            {/* <SwiperSlide>
                                <div className="item">
                                    <div className="icon">
                                        <img src={HonorSwiper02} alt=""/>
                                    </div>
                                    <div className="text">
                                        道路运输经营许可证
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="item">
                                    <div className="icon">
                                        <img src={HonorSwiper03} alt=""/>
                                    </div>
                                    <div className="text">
                                        信息安全备案证明
                                    </div>
                                </div>
                            </SwiperSlide> */}
                            <SwiperSlide>
                                <div className="item">
                                    <div className="icon">
                                        <img src={HonorSwiper04} alt=""/>
                                    </div>
                                    <div className="text">
                                        计算机软件著作权登记证书
                                    </div>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                        <div className="control">
                            <div className="swiper-honor-prev">&lt;</div>
                            <div className="swiper-honor-next">&gt;</div>
                        </div>
                    </div>
                </div>
                <div className="honor-product">
                    <div className="honor-product-title">
                        <div className="title">
                            Products <span>Show</span>
                        </div>
                        <div className="text">
                            产品展示
                        </div>
                    </div>
                    <img src={HonorProduct01} alt=""/>
                </div>
            </div>
        );
    }
}

export default AboutHonor;
